import apiService from '../api/api.service';
import {
  ReferralCampaign,
  CampaignStats,
  CreateCampaignRequest,
  UpdateCampaignRequest
} from '../../types/referral.types';

class ReferralCampaignService {
  private static instance: ReferralCampaignService;

  private constructor() {}

  public static getInstance(): ReferralCampaignService {
    if (!ReferralCampaignService.instance) {
      ReferralCampaignService.instance = new ReferralCampaignService();
    }
    return ReferralCampaignService.instance;
  }

  /**
   * Tüm kampanyaları getir (Süper Admin)
   */
  public async getCampaigns(): Promise<ReferralCampaign[]> {
    const response = await apiService.get<ReferralCampaign[]>('/super-admin/referral-campaigns');
    return response;
  }

  /**
   * Kampanya detayını getir
   */
  public async getCampaignById(id: string): Promise<ReferralCampaign> {
    const response = await apiService.get<ReferralCampaign>(`/super-admin/referral-campaigns/${id}`);
    return response;
  }

  /**
   * Yeni kampanya oluştur
   */
  public async createCampaign(data: CreateCampaignRequest): Promise<ReferralCampaign> {
    const response = await apiService.post<ReferralCampaign>('/super-admin/referral-campaigns', data);
    return response;
  }

  /**
   * Kampanya güncelle
   */
  public async updateCampaign(data: UpdateCampaignRequest): Promise<ReferralCampaign> {
    const { id, ...updateData } = data;
    const response = await apiService.put<ReferralCampaign>(`/super-admin/referral-campaigns/${id}`, updateData);
    return response;
  }

  /**
   * Kampanya sil
   */
  public async deleteCampaign(id: string): Promise<void> {
    await apiService.delete(`/super-admin/referral-campaigns/${id}`);
  }

  /**
   * Kampanya istatistiklerini getir
   */
  public async getStats(): Promise<CampaignStats[]> {
    const response = await apiService.get<CampaignStats[]>('/super-admin/referral-campaigns/stats');
    return response;
  }
}

export default ReferralCampaignService.getInstance();

